import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateUtils } from 'ng-jhipster';
import { Principal } from '../../shared';
import { CustomDatePipe } from '../../shared/utils/date.pipe';
import { CampaignService } from '../campaign/campaign.service';
import { MasterProposal, PropositionStatus } from '../master-proposal/master-proposal.model';
import { MasterProposalService } from '../master-proposal/master-proposal.service';
import { MasterService } from '../master/master.service';
import { PropertiesService } from './properties.service';
import { Saisine, SaisineStatus } from './saisine.model';



@Component({
    selector: 'jhi-saisine-alert',
    templateUrl: 'saisine-alert.component.html'
})

export class SaisineAlertComponent implements OnChanges {

    @Input()
    saisine: Saisine;

    @Output() saisineChange = new EventEmitter();

    saisineStatus: any = SaisineStatus;
    propositionStatus: any = PropositionStatus;
    statusTRC: any[];
    confirmedMasterPrposal: MasterProposal;
    refusedMasterProposal: MasterProposal;
    isMasterProposalConfirmed = false;
    modal: any;
    dateTreated: any;
    isLastOneRefused: boolean;

    constructor(
        private masterProposalService: MasterProposalService,
        public masterService: MasterService,
        private modalService: NgbModal,
        private propertiesService: PropertiesService,
        private datePipe: CustomDatePipe,
        public principal: Principal,
        public campaignService: CampaignService,
        private dateUtils: DateUtils
    ) { }

    ngOnChanges(changes: SimpleChanges) {
        this.statusTRC = [PropositionStatus.TRANSMITTED, PropositionStatus.REFUSED, PropositionStatus.CONFIRMED];

        if (this.saisine.hasStatus(SaisineStatus.TREATED)) {
            let date = new Date(this.saisine.treatedDate);
            date.setDate(date.getDate() + Number(this.propertiesService.properties.delay));
            this.dateTreated = this.datePipe.transform(date);
        } else if (this.saisine.hasStatus(SaisineStatus.ABANDONED)) {
            let date = new Date(this.saisine.abandonedDate);
            this.saisine.abandonedDate = this.datePipe.transform(date);
        }
    }

    confirmMasterProposal() {
        this.masterProposalService.updateMPToConfirmed(this.saisine.id, this.confirmedMasterPrposal).subscribe(m => this.saisineChange.emit());
    }

    refuseMasterProposal() {
        this.masterProposalService.updateMPToRefused(this.saisine.id, this.refusedMasterProposal).subscribe(m => this.saisineChange.emit());
    }

    // modal
    openConfirmMasterProposal(content, mp: MasterProposal) {
        this.confirmedMasterPrposal = mp;
        this.modal = content;
        this.modalService.open(content).result.then((result) => {
            this.isMasterProposalConfirmed = true;
            this.confirmMasterProposal();
        }, (reason) => { });
    }

    openRefuseMasterProposal(content, rmp: MasterProposal) {
        this.isLastOneRefused = (this.saisine.masterProposals.filter(mp => mp.status === PropositionStatus.TRANSMITTED).length === 1 && this.saisine.status === SaisineStatus.TREATED);
        this.refusedMasterProposal = rmp;
        this.modal = content;
        this.modalService.open(content).result.then((result) => {
            this.refuseMasterProposal();
        }, (reason) => { });
    }
    encodeURI = (uri: string): string => encodeURI(uri);

    getRefusedProposalDate(studentProposalDate: any): string {
        let date = this.dateUtils.convertDateTimeFromServer(studentProposalDate);
        date.setDate(date.getDate() + Number(this.propertiesService.properties.delay));
        return this.datePipe.transform(date);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine-alert.component.ts